import { render } from "./FilesUploaded.vue?vue&type=template&id=5d19f606&scoped=true"
import script from "./FilesUploaded.vue?vue&type=script&lang=js"
export * from "./FilesUploaded.vue?vue&type=script&lang=js"

import "./FilesUploaded.vue?vue&type=style&index=0&id=5d19f606&scoped=true&lang=css"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d19f606"]])

export default __exports__